import React from "react";
import { Table, Columns, TableSortState } from "components/table";
import Pagination from "components/table/pagination";
import Typography from "components/typography";
import { FleetRow } from "../types";

interface ListTableProps {
  t: any;
  paginatedRows: FleetRow[];
  isLoading: boolean;
  isFetching: boolean;
  columns: Columns<FleetRow>[];
  currentPage: number;
  rowsPerPage: number;
  setRowsPerPage: (rows: number) => void;
  setCurrentPage: (page: number) => void;
  selectedKeys: (string | number)[];
  setSelectedKeys: (keys: (string | number)[]) => void;
  sortState: TableSortState;
  setSortState: (state: TableSortState) => void;
  totalPages: number;
  onRowClick?: (row: FleetRow) => void;
}

const ListTable: React.FC<ListTableProps> = ({
  t,
  paginatedRows,
  isLoading,
  isFetching,
  columns,
  currentPage,
  rowsPerPage,
  setRowsPerPage,
  setCurrentPage,
  selectedKeys,
  setSelectedKeys,
  sortState,
  setSortState,
  totalPages,
  onRowClick,
}) => {
  return (
    <section className={`rounded-2xl border border-border bg-white shadow-sm overflow-hidden transition-opacity duration-200 ${isFetching && !isLoading ? "opacity-60 pointer-events-none" : ""}`}>
      <Table<FleetRow>
        data={paginatedRows}
        loading={isLoading}
        columns={columns}
        rowKey="id"
        currentPage={currentPage}
        limit={rowsPerPage}
        selectable
        selectedRowKeys={selectedKeys}
        onSelectedRowKeysChange={(keys) => setSelectedKeys(keys)}
        sortState={sortState}
        onSortStateChange={setSortState}
        onRowClick={onRowClick}
        selectableLabel="All"
        stickySelectable
        data-testid="table-fleet-list"
      />

      <div className="flex items-center justify-between px-6 py-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Typography variant="body" tone="muted" as="span">
            {t("rows-per-page")}
          </Typography>
          <select
            value={rowsPerPage}
            onChange={(event) => {
              setRowsPerPage(Number(event.target.value));
              setCurrentPage(1);
            }}
            className="border border-border rounded-lg px-2 py-1 text-sm bg-white cursor-pointer"
            data-testid="select-rows-per-page"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>

        <div data-testid="pagination-fleet">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </section>
  );
};

export default ListTable;
